export default "__VITE_ASSET__BNMV2SEc__"